import { styled } from "styled-components";

export const StyledLogoWrapper = styled.div`
    background-color: #FFBE0A;
    width: 100%;
    height: 25.5rem;

    @media (min-width: 768px) {
        height: 100vh;
        width: 50%;
    }
`;